import { createTheme } from '@mui/material/styles';

export const ThemeBackOffice = createTheme({
  palette: {
    error: { main: '#f66868' },
    primary: { main: '#2544ca' },
    secondary: { main: '#414B5C' },
  },
  zIndex: {
    mobileStepper: 1000,
    speedDial: 1050,
    appBar: 1100,
    drawer: 1200,
    modal: 1300,
    snackbar: 1400,
    tooltip: 1500,
  },
  components: {
    MuiAccordion: {
      styleOverrides: {
        root: {
          '&:before': {
            display: 'none',
          },
        },
      },
    },
    MuiAccordionSummary: {
      styleOverrides: {
        root: {
          minHeight: 'inherit',
          padding: 0,
          '&.Mui-expanded': {
            minHeight: 'inherit',
          },
        },
        content: {
          margin: 0,
          '&.Mui-expanded': {
            margin: 0,
          },
        },
        expandIconWrapper: {
          marginRight: 5,
          padding: 12,
        },
      },
    },
    MuiAccordionDetails: {
      styleOverrides: {
        root: {
          display: 'flex',
          minHeight: 'inherit',
          padding: 0,
        },
      },
    },
    MuiTabs: {
      defaultProps: {
        textColor: 'inherit',
        indicatorColor: 'secondary',
      },
    },
    MuiTab: {
      styleOverrides: {
        root: {
          color: 'inherit',
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          borderRadius: 8,
          border: '1px solid #DFE5EC',
          boxShadow: 'none',
        },
      },
    },
    MuiCardContent: {
      styleOverrides: {
        root: {
          padding: 16,
        },
      },
    },
    MuiTooltip: {
      styleOverrides: {
        tooltip: {
          borderRadius: 8,
          backgroundColor: '#414B5C',
          color: '#FFF',
          fontSize: 12,
          fontWeight: 600,
        },
      },
    },
    MuiFormControlLabel: {
      styleOverrides: {
        root: {
          color: '#8c99ad',
          fontSize: 12,
          lineHeight: 23,
        },
        label: {
          fontSize: 14,
        },
      },
    },
    MuiPopover: {
      styleOverrides: {
        root: {
          zIndex: '9000 !important',
        },
      },
    },
    MuiBadge: {
      styleOverrides: {
        badge: {
          minWidth: 28,
          height: 28,
          borderRadius: '50%',
        },
      },
    },
  },
});
